import React from "react";

// components
import Bio from "../Bio";

// assets
import bioImg from "../../../assets/images/ErikRostvold.jpg";

const ErikRBio = (props) => {
  const bioData = {
    title: "Erik Rostvold",
    title2: "Chief Risk Officer",
    hashName: "erik-rostvold",
    bio1: `Erik Rostvold has served as Chief Risk Officer of our advisor and our sponsor and member of the

investment committee of our sponsor since October 2024. Mr. Rostvold has served as Chief Risk Officer of

StratCap Securities, LLC since October 2024. He also served as a Senior Vice President of our Sponsor

from June 2018 through October 2024, and Senior Vice President, Product Management of StratCap

Securities, LLC from October 2013 through October 2024. Mr. Rostvold has over 24 years of experience in

financial services and investment management with 18 years of experience in alternative investments,

focusing on commercial real estate, fixed income and digital infrastructure real estate. Mr. Rostvold has

been involved in the formation and capital raise for over $20B in alternative investment offerings.

Mr. Rostvold currently oversees retail fund development, ongoing fund management, investor services, due

diligence and risk oversight for StratCap. Prior to StratCap, Mr. Rostvold was Director of Product

Management at Cole Real Estate Investments and has held other product management and sales positions

with KBS Capital Markets Group, MetLife, and Pacific Life. Mr. Rostvold holds a Bachelor of Science in

Business Administration from the University of Arizona with a major in Business Management and

certificate in International Business.`,
  };
  return (
    <Bio
      srcImg={bioImg}
      title1={bioData.title}
      title2={bioData.title2}
      hashName={bioData.hashName}
      bio1={bioData.bio1}
      closeBio={props.closeBio}
    />
  );
};

export default ErikRBio;
